import React from 'react';
import { Button, ButtonGroup } from "react-bootstrap";

const Row = ({ event, onUpdate, onRemove }) => (
    <tr>
        <td>{event.summary}</td>
        <td>{event.description}</td>
        <td>{event.url}</td>
        <td>{event.alarm1Trigger}</td>
        <td>{event.alarm1Description}</td>
        <td>{event.alarm2Trigger}</td>
        <td>{event.alarm2Description}</td>
        <td>
            <ButtonGroup>
                <Button bsStyle="info" onClick={() => onUpdate(event)}>Update</Button>
                <Button bsStyle="danger" onClick={() => onRemove(event.id)}>Remove</Button>
            </ButtonGroup>
        </td>
    </tr>
);

export default Row;



// WEBPACK FOOTER //
// ./src/scenes/CalendarEvents/components/Table/components/Row/index.js